import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminDockerImages = {
  pageTitle: "共有コンテナーイメージ",
  pageSubtitle:
    "Environment Center で有効化され共有されているコンテナーイメージを、業務インスタンス化と参照確認のために読み取り専用で表示します。",
  summary: {
    total: "イメージ総数：{count}",
    configuredPorts: "設定済みポート：{count}",
    defaultPorts: "既定ポート：{count}",
    sourceSnapshots: "元インスタンススナップショット：{count}",
  },
  guidance: {
    baseImageHint:
      "この一覧は Environment Center の共有イメージ投影ビューであり、インスタンス化と参照確認にのみ使用します。",
  },
  table: {
    code: commonShortFieldLabels.code,
    name: "イメージ識別子",
    displayName: "イメージ名称",
    id: "ID",
    size: "サイズ",
    declaredPorts: "宣言ポート",
    effectivePorts: "有効ポート",
    createdAt: commonShortFieldLabels.createdAt,
    description: "説明",
    tags: "タグ",
    sourceInstance: "元インスタンス",
    businessReferences: "業務参照",
    status: commonShortNouns.status,
    actions: "操作",
  },
  references: {
    referenceType: "参照タイプ",
    resourceType: "リソースタイプ",
    resourceId: "リソース ID",
    label: "表示名",
    status: commonShortNouns.status,
    updatedAt: commonShortFieldLabels.updatedAt,
    totalReferences: "参照総数：",
  },
  dialogs: {
    pullTitle: "イメージをプル",
    importTitle: "イメージパッケージ（tar）をインポート",
    importHint:
      "`docker save` でエクスポートしたイメージパッケージをインポートできます。インポート後、イメージ一覧は自動更新されます。",
    currentFile: "現在のファイル：{name}",
    noFileSelected: "ファイルが選択されていません",
    buildDockerfileTitle: "Dockerfile からイメージを構築",
    metadataTitle: "イメージポート設定",
    customFieldsTitle: "イメージのカスタム項目",
    declaredPortsTitle: "イメージ宣言ポート（EXPOSE）",
    selectablePortsTitle: "選択可能ポート",
    defaultPortTitle: "既定ポート",
    instantiateTitle: "イメージをインスタンス化",
    referenceTitle: "イメージ業務参照",
  },
  form: {
    imageName: "イメージ識別子",
    imageNameRequired: "イメージ識別子を入力してください",
    imageNamePlaceholder: "例：nginx:alpine",
    importSource: "インポート元",
    importSourceUpload: "ブラウザーで tar をアップロード",
    importSourceAsset: "アセットから tar を選択",
    assetPlaceholder: "tar アセットを検索して選択",
    assetHint:
      "大容量アップロードの不安定さを避けるため、先にアセットへアップロードしてからここで選択してください。",
    description: "説明",
    descriptionPlaceholder: "イメージ説明",
    tags: "タグ（カンマ区切り）",
    tagsPlaceholder: "例：v1.1,practical",
    dockerfileContent: "Dockerfile 内容",
    dockerfileContentRequired: "Dockerfile 内容を入力してください",
    dockerfileContentPlaceholder: "例:\nFROM nginx:alpine\nCOPY ./site /usr/share/nginx/html",
    buildArgsJson: "Build Args JSON（任意）",
    buildArgsJsonPlaceholder: '例: {"HTTP_PROXY":"http://proxy:3128"}',
    noCacheBuild: "キャッシュなしで構築（--no-cache）",
    buildArgsJsonInvalid: "Build Args JSON の形式が不正です。オブジェクト形式が必要です。",
    noDeclaredPorts: "このイメージはポートを宣言していません。先にイメージで EXPOSE してください。",
    selectAllPorts: "すべて選択",
    clearPorts: "クリア",
    selectAtLeastOnePort: "選択可能ポートを少なくとも 1 つ選択してください。",
    selectSelectablePortFirst:
      "先に「選択可能ポート」で少なくとも 1 つのポートを選択してください。",
    currentPortConfig: "現在の設定：選択可能 {count} 個、既定 {port}",
    metadataHint:
      "問題作成時はこの設定に基づいてポートのドロップダウンを表示します。未設定の場合は、イメージの宣言ポートに戻ります。",
  },
  actions: {
    importTar: "tar をインポート",
    buildDockerfile: "Dockerfile 構築",
    startBuild: "構築開始",
    pullImage: "イメージをプル",
    viewReferences: "参照を表示",
    instantiate: "インスタンス化",
    configurePorts: "ポート設定",
    customFields: "カスタム項目",
  },
  statuses: {
    available: "利用可能",
  },
  confirmDelete: {
    title: "このイメージを削除しますか？",
  },
  messages: {
    pullSuccess: "イメージのプルが完了しました",
    removeSuccess: "イメージを削除しました",
    importSuccess: "イメージのインポートが完了しました",
    importSuccessWithCount:
      "イメージのインポートが完了しました。{count} 個のイメージを検出しました",
    buildSuccess: "イメージ構築が完了しました",
    buildSuccessWithImage: "イメージ構築が完了しました：{image}",
    metadataUpdated: "イメージポート設定を更新しました",
    customFieldsSaved: "イメージのカスタム項目を保存しました",
  },
  logs: {
    importTitle: "インポートログ",
    buildTitle: "構築ログ",
  },
} as const;
